/** Returns the MUI Chip color for a kontrola/hydrant stav value. */
export const kontrolaStavColor = (stav: string): 'success' | 'error' | 'warning' => {
  if (stav === 'OK') return 'success';
  if (stav === 'ZAVADA') return 'error';
  return 'warning';
};
